import { AxiosResponse } from 'axios';
import { GenericProductGetDTO } from 'svila-common';
import { API_URL } from '../../utils/constants';

import request from '../request';

export default {
  getList: async (values): Promise<AxiosResponse<GenericProductGetDTO>> => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/products/generics/get`, 'post', body, {});
  },

  get: async (id): Promise<AxiosResponse<GenericProductGetDTO>> => {
    return request(`${API_URL}/products/generics/${id}`, 'get');
  },

  update: async (id, values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/products/generics/${id}`, 'put', body, {});
  },

  create: async (values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/products/generics/`, 'post', body, {});
  },

  delete: async (id) => {
    return request(`${API_URL}/products/generics/${id}`, 'delete', {}, {});
  },

  getProductInStockPeriod: async (id: string) => {
    return request(`${API_URL}/products/generics/get-products-in-stock-period/${id}`, 'get');
  },

  getProductInStockPeriodInWarehouse: async (warehouseId: string, genericProductId: string) => {
    return request(`${API_URL}/products/generics/get-products-in-stock-period/${warehouseId}/${genericProductId}`, 'get');
  }
}